document.addEventListener("DOMContentLoaded", function () {


    var elem = document.querySelectorAll('.main-carousel');
    
    //console.log("main slider section");
    //console.log("main slider first selected :",elem)
    elem.forEach(element => {

        if(!element.classList.contains("flickity-enabled"))
        {
            //console.log("main slider implented :",element)

            var flkty = new Flickity( element, {
                // options
                cellAlign: 'left',
                contain: true,
                wrapAround:true,
                pageDots:false
                });

        }
        
        
    });
    
})